import React from "react";

const LogContext = React.createContext({
  campaigns: {},
  categories: {}
});

export default LogContext;
